import React from 'react';
import '../../../components/shared/Hero.css'; 

function Hero() {
  return (
    <section className="Sect">
      <img src="/Logo&Cloth/img with blur.png" alt="Curtain" className="Sect-img" />
      <div className="Sect-text">
        <img src="/Logo&Cloth/pic1.png" alt="Curtain" className="logo" />
        <h1>Contact Us</h1>
        <p>Get in touch with us</p>
        
      </div>
    </section>
  );
}

export default Hero;